/**
 * This enum is used for type safety with interface key names, in place of something like C#'s nameof function.
 * Keys only need to be added here if they're also used as string values and need to match.
 */
export enum MapPropertyKeysEnum {
  CountySsa = "countySSA",
  Covered = "covered",
  ProjectionType = "projectionType",
  ProviderNetworkType = "providerNetworkType",
  ProviderUniqueId = "providerUniqueId",
  IsGap = "isGap",
  NumberOfSpecialtyCodeWithGaps = "numberOfSpecialtyCodeWithGaps",
  ZipCode = "zipCode",
  ScenarioModelProviderStatus = "scenarioModelProviderStatus",
  County = "county",
  Selected = "selected"
}
